import { orderBy } from "lodash";
import React from "react"
import { AccountData } from "../../generated";
import { canRequireUser } from "../../login/loginHelpers";
import NewsRepository from "../NewsRepository"

export const NewsViewer = canRequireUser((props: { user: AccountData | null }) => {
    const availableNews = NewsRepository.getForUser(props.user);
    const newsToRead = availableNews.length > 0 ? availableNews : NewsRepository.getAll();
    const orderedNews = orderBy(newsToRead, x => x.version.getValue(), ["desc"]);

    return <>
        {
            orderedNews.map((news, i) => (
                <div key={i} className="text-center">
                    <h2 className="badge bg-danger text-white text-wrap" style={{ fontSize: "2rem" }}>{news.title}</h2>
                    <div className="fw-bold">{news.description}</div>
                    {news.images.map((image, k) => (
                        <div className="mt-3 mb-3" key={i + k}>
                            {image.imageDescription && <div>{image.imageDescription}</div>}
                            <img src={image.url} className="img-fluid" />
                        </div>)
                    )}
                    {orderedNews.length > 1 && i < orderedNews.length - 1 && <div className="mb-5 mt-5 w-100 ps-5 pe-5">
                        <div className="w-100 bg-secondary" style={{ height: 10, borderRadius: 5 }} />
                    </div>}
                </div>
            ))
        }
    </>
})